<template>
  <div class="view-more">
    <!-- ----- -->
    <div class="team-more">
      <div class="view-box">
        <div class="teamInfo">
          <div class="team-img">
            <img class="img" :src="TeamInfo.temp_icon_path_url" alt="" />
          </div>
          <div class="team-name">{{ TeamInfo.name }}</div>
          <div class="team-grade">{{ championInfo }}</div>
        </div>
        <div class="gradeInfo">
          <p class="view-title">TEAM-STATS</p>
          <div class="view-body">
            <div class="view-head" v-if="titleHeader">
              <p
                class="header"
                v-for="(item, index) in titleHeader.slice(0, 6)"
                :key="index"
              >
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.full_title"
                  placement="top"
                >
                  <span>{{ item.label }}</span>
                </el-tooltip>
              </p>
            </div>
            <div class="view-con" v-if="numList">
              <p
                class="header"
                v-for="(item, index) in titleHeader.slice(0, 6)"
                :key="index"
              >
                {{ numList[item.value] }}
              </p>
            </div>
          </div>

          <div class="view-body">
            <div class="view-head" v-if="titleHeader">
              <p
                class="header"
                v-for="(item, index) in titleHeader.slice(6, 12)"
                :key="index"
              >
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.full_title"
                  placement="top"
                >
                  <span>{{ item.label }}</span>
                </el-tooltip>
              </p>
            </div>
            <div class="view-con" v-if="numList">
              <p
                class="header"
                v-for="(item, index) in titleHeader.slice(6, 12)"
                :key="index"
              >
                {{ numList[item.value] }}
              </p>
            </div>
          </div>

          <div class="view-body" v-if="titleHeader">
            <div class="view-head">
              <p
                class="header"
                v-for="(item, index) in titleHeader.slice(12, 18)"
                :key="index"
              >
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.full_title"
                  placement="top"
                >
                  <span>{{ item.label }}</span>
                </el-tooltip>
              </p>
            </div>
            <div class="view-con" v-if="numList">
              <p
                class="header"
                v-for="(item, index) in titleHeader.slice(12, 18)"
                :key="index"
              >
                {{ numList[item.value] }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="close" @click="close">×</div>
      <div class="team-box">
        <div
          class="team-member"
          v-for="(item, index) in TeamMember"
          :key="index"
        >
          <img class="img" :src="item.team_member.temp_icon_path_url" alt="" />
          <p>{{ item.team_member.name }}</p>
        </div>
      </div>
      <div class="member-stats">
        <p class="view-title">MEMBERS-STATS</p>
        <template>
          <el-table
            stripe
            max-height="500"
            :empty-text="$t('home.nodata')"
            class="champion_table"
            :data="MemberStats"
            border
          >
            <el-table-column
              fixed
              width="120px"
              label="NAME"
              prop="team_member_name"
            >
            </el-table-column>
            <el-table-column
              width="61px"
              v-for="(item, index) in titleHeader"
              :key="index"
              :prop="item.value"
            >
              <template slot="header">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.full_title"
                  placement="top"
                >
                  <span
                    class="table-header"
                    style="display:block;text-align:center;"
                    >{{ item.label }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import titleHeader from "../../../commen/commen_title";

export default {
  mixins: [titleHeader],
  props: [
    "headList",
    "numList",
    "TeamMember",
    "MemberList",
    "MemberStats",
    "TeamInfo",
    "championInfo"
  ],
  data() {
    return {
      memberList: [
        "NAME",
        "FGM",
        "FGA",
        "FG%",
        "Three_PM",
        "Three_PA",
        "Three_P%",
        "FTM",
        "FTA",
        "FT%",
        "OREB",
        "DREB",
        "REB",
        "AST",
        "STL",
        "BLK",
        "TO",
        "PF",
        "PTS"
      ]
    };
  },
  // computed: {
  //   ...mapState(["headType"])
  // },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.el-tooltip__popper {
  z-index: 4001 !important;
}
.champion_table {
  margin-top: 30px;
  border-radius: 15px;
  box-shadow: 2px 2px 10px rgb(219, 217, 217);
  thead {
    tr {
      th {
        background: #2d3b51 !important;
        .cell {
          color: #fff !important;
          display: flex !important;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.view-more {
  width: 100%;
  padding: 20px 30px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.507);
  z-index: 4000;
  .view-title {
    line-height: 50px;
    font-weight: 600;
    font-size: 25px;
  }
  .view-box {
    display: flex;
    width: 90%;
    margin-left: 5%;
    .teamInfo {
      width: 40%;
      // background: #2d3b516e;
      box-shadow: 2px 2px 15px rgb(180, 180, 180);
      border-radius: 20px;
      .team-img {
        height: auto;
        // width: 150px;
        margin: auto;
        margin-top: 30px;
        .img {
          width: 80%;
          height: 100%;
          object-fit: cover;
          object-position: top;
        }
      }
      .team-name {
        font-weight: 600;
        font-size: 25px;
        color: #2d3b51;
        line-height: 35px;
        margin-top: 15px;
      }
      .team-grade {
        font-weight: 600;
        font-size: 50px;
        color: #2d3b51;
      }
    }
    .gradeInfo {
      width: 50%;
      margin-left: 10%;
      .view-head {
        display: flex;
        justify-content: space-around;
        background: #2d3b51;
        padding: 10px 0;
        border-radius: 5px;
        color: #fff;
      }
      .header {
        width: 15%;
      }
      .view-con {
        display: flex;
        justify-content: space-around;
        padding: 20px 0;
      }
    }
  }
  .team-more {
    background: #fff;
    position: absolute;
    width: 90%;
    height: 95%;
    overflow-y: scroll;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;

    .close {
      position: absolute;
      right: 20px;
      top: 10px;
      font-weight: 600;
      font-size: 25px;
      cursor: pointer;
    }
    .team-box {
      display: flex;
      margin-top: 70px;
      width: 70%;
      margin-left: 15%;
      flex-wrap: wrap;
      .team-member {
        // margin-right: 20px;
        margin-bottom: 50px;
        width: 20%;
        height: 120px;
        .img {
          border-radius: 50%;
          width: 80px;
          height: 80px;
          object-fit: cover;
          object-position: top;
        }
      }
    }
    .member-stats {
      padding: 20px;
      border-radius: 10px;
      margin-top: 40px;
      .table {
        width: 100%;
        .table-header {
          font-size: 17px;
          background: #2d3b51;
          color: #fff;
          height: 40px;
        }
        tbody {
          tr {
            height: 35px;
            transition: all 0.6s;
            .member-name {
              font-weight: 600;
            }
          }
          tr:nth-child(2n) {
            background: rgb(223, 223, 223);
          }
          tr:hover {
            height: 40px;
            background: #000;
            color: #fff;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .view-more {
    .team-more {
      padding: 10px;
      padding-top: 40px;
      .view-box {
        flex-direction: column;
        width: 100%;
        margin-left: 0;
        .teamInfo {
          width: 100%;
        }
        .gradeInfo {
          width: 100%;
          margin-left: 0;

          .header {
            font-size: 12px;
          }
        }
      }
      .team-box {
        width: 90%;
        margin-left: 5%;
        .team-member {
          margin: 40px 10px;
          height: 70px;
          width: 70px;
          .img {
            width: 60px;
            height: 60px;
          }
        }
      }
      .member-stats {
        overflow-x: scroll;
        .table {
          width: 1560px;
        }
      }
    }
  }
}
</style>
